import { callFes, callFesWithLoading } from '..';

export const getCustomer = async (
  milesCustomerId: string
): Promise<CustomerIntegration.Schemas.GetCustomerByIdResponse> => {
  return callFes.getMiles(`customers/${milesCustomerId}`);
};

export const createStakeholderContact = async (
  customerId: string,
  data: CustomerIntegration.Schemas.CustomerDataCreateStakeholderContactsRequest
): Promise<CustomerIntegration.Schemas.CustomerDataCreateStakeholderContactsResponse> => {
  return callFesWithLoading.postMiles(`customers/${customerId}/stakeholder-contacts`, data);
};

export const updateStakeholderContact = async (
  customerId: string,
  stakeholderContactId: string,
  data: CustomerIntegration.Schemas.UpdateStakeholderContactsRequest
): Promise<CustomerIntegration.Schemas.UpdateStakeholderContactsResponse> => {
  return callFesWithLoading.patchMiles(`customers/${customerId}/stakeholder-contacts/${stakeholderContactId}`, data);
};

export const removeStakeholderContact = async (
  customerId: string,
  stakeholderContactId: string
): Promise<CustomerIntegration.Schemas.CustomerDataCreateStakeholderContactsResponse> => {
  return callFesWithLoading.deleteMiles(`customers/${customerId}/stakeholder-contacts/${stakeholderContactId}`);
};

export const getStakeholderContacts = async (customerId: string) => {
  return callFes.getMiles<CustomerIntegration.Schemas.GetStakeholderContactsResponse>(
    `customers/${customerId}/stakeholder-contacts`
  );
};
